import { connect } from 'react-redux'
import { compose } from 'redux'
import { wpDataUpdateRequest } from '../actions'

const mapStateToProps = state => ({
    status: state.getIn(['wpLocalData', 'data', 'status'])
})

const mapDispatchToProps = dispatch => ({
    saveState: () => {
        dispatch(wpDataUpdateRequest())
    }
})

const hasSaveWPData = () => WrappedComponent => {
    const HasSaveWPData = props => <WrappedComponent {...props} />

    return compose(
        connect(mapStateToProps, mapDispatchToProps)
    )(HasSaveWPData )
}

export default hasSaveWPData